import { Link, useLocation } from "react-router-dom";
import { ArrowRight, Flag, Mail } from "lucide-react";
import { AIQUIRES_LOGO, BRAND, LOGO_URL } from "./constants";

const Footer = ({ variant = "full" }) => {
  const location = useLocation();
  const isLandingPage = location.pathname === "/";

  if (variant === "compact") {
    return (
      <footer className="border-t border-gray-200 bg-white py-8">
        <div className="container-main flex flex-col items-center justify-between gap-4 sm:flex-row">
          <p className="text-sm text-gray-500">© 2026 {isLandingPage ? "AiQuireS" : BRAND.parent}.</p>
          <div className="flex gap-4 text-sm"><Link to="/" className="text-gray-500 hover:text-[#00a3e0]">Home</Link><Link to="/terms" className="text-gray-500 hover:text-[#00a3e0]">Terms</Link><Link to="/privacy" className="text-gray-500 hover:text-[#00a3e0]">Privacy</Link></div>
        </div>
      </footer>
    );
  }

  return (
    <footer className="border-t border-gray-200 bg-gray-50 py-14">
      <div className="container-main">
        <div className="grid items-start gap-x-10 gap-y-9 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <img src={isLandingPage ? AIQUIRES_LOGO : LOGO_URL} alt={isLandingPage ? "AiQuireS" : BRAND.parent} className={isLandingPage ? "h-16 w-auto max-w-[200px] object-contain" : "h-8 w-auto object-contain"} />
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-gray-600">Career intelligence built around the truth of your experience.</p>
          </div>
          <div>
            <h4 className="flex min-h-8 items-center font-semibold text-[#071734]">Career Tools</h4>
            <ul className="mt-4 space-y-2 text-sm leading-6">
              <li><Link to="/resume" className="flex min-h-6 items-center gap-2 text-gray-600 hover:text-[#00a3e0]"><ArrowRight className="h-4 w-4 shrink-0" /> Career Profiler</Link></li>
              <li><Link to="/veterans" className="flex min-h-6 items-center gap-2 text-red-600 hover:text-red-500"><Flag className="h-4 w-4 shrink-0" /> Military discount</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="flex min-h-8 items-center font-semibold text-[#071734]">Coming Soon</h4>
            <ul className="mt-4 space-y-2 text-sm leading-6">
              <li className="text-gray-500">Phoenix MSP Tools</li>
              <li><Link to="/scribe-flow-studio" className="text-purple-600 hover:text-purple-500">Scribe Flow Studio</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="flex min-h-8 items-center font-semibold text-[#071734]">Support</h4>
            <a href="mailto:aaron@aiquires.com?subject=AiQuireS%20Support" className="mt-4 flex min-h-6 items-center gap-2 text-sm leading-6 text-gray-600 hover:text-[#00a3e0]"><Mail className="h-4 w-4 shrink-0" /> aaron@aiquires.com</a>
            <div className="mt-2 flex min-h-6 items-center gap-4 text-sm leading-6"><Link to="/terms" className="text-gray-500 hover:text-[#00a3e0]">Terms</Link><Link to="/privacy" className="text-gray-500 hover:text-[#00a3e0]">Privacy</Link></div>
          </div>
        </div>
        <div className="mt-10 border-t border-gray-200 pt-7">
          <div className="mx-auto max-w-4xl rounded-xl border border-amber-200 bg-amber-50 p-4">
            <p className="text-center text-xs leading-relaxed text-amber-900"><strong>Review before use:</strong> AiQuireS uses source-based generation rules designed to minimize unsupported information. AI-generated documents may still contain errors. Confirm all dates, credentials, accomplishments, and other details before applying.</p>
          </div>
          <p className="mt-6 text-center text-sm text-gray-500">© 2026 {isLandingPage ? "AiQuireS" : BRAND.parent}. {BRAND.tagline}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
